import { render } from "./SmallMusicPlayer.vue?vue&type=template&id=a64ea8a2&scoped=true"
import script from "./SmallMusicPlayer.vue?vue&type=script&lang=js"
export * from "./SmallMusicPlayer.vue?vue&type=script&lang=js"

import "./SmallMusicPlayer.vue?vue&type=style&index=0&id=a64ea8a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a64ea8a2"

export default script